/**
 * Schreibrechte des angemeldeten Benutzers.
 * Der Wert kommt beim Login aus /api/me (canWrite) und wird in app.ts einmalig
 * gesetzt, damit die Seiten ihn abfragen können, ohne app.ts zu importieren.
 *
 * Reine Anzeige-Logik: Die verbindliche Prüfung passiert im Backend
 * (writeAccessMiddleware in backend/src/auth.ts).
 */

let writeAccess = true;

export function setWriteAccess(value: boolean): void {
  writeAccess = value;
}

export function canWrite(): boolean {
  return writeAccess;
}

/** Blendet Schreib-Bedienelemente in Template-Strings aus. */
export function writeOnly(html: string): string {
  return writeAccess ? html : "";
}

/**
 * Sperrt für Betrachter alle Eingabefelder eines Bereichs, damit umfangreiche
 * Formulare lesbar bleiben, ohne jedes Feld einzeln behandeln zu müssen.
 * Felder mit data-readable="true" bleiben bedienbar (z.B. Suche und Filter).
 */
export function lockInputs(root: HTMLElement): void {
  if (writeAccess) return;
  root.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
    "input:not([data-readable]), select:not([data-readable]), textarea:not([data-readable])"
  ).forEach(field => { field.disabled = true; });
}

/** Hinweisleiste für Betrachter, damit fehlende Schaltflächen nicht wie ein Fehler wirken. */
export function readOnlyNotice(): string {
  if (writeAccess) return "";
  return `<div class="alert alert-info">Du hast Leserechte. Änderungen sind mit der Rolle „Betrachter" nicht möglich.</div>`;
}
